import React, { useState } from "react";
import LandscapeProgramLayout from "../LandscapeProgramLayout";
import BottomNav from "../BottomNav";
import { useAuthContext } from "../../../context/auth";

function IceBreaking() {
  const [start, setStart] = useState(false);
  const { circuitProgram, weightProgram, hiluxProgram, timer, did } =
    useAuthContext();
  const program = hiluxProgram ?? circuitProgram ?? weightProgram;
  return (
    <LandscapeProgramLayout step={1}>
      <div className="w-full flex-1 flex flex-col justify-center items-center">
        <div
          className="relative w-full h-full"
          style={{
            backgroundImage: `url("./main.png")`,
            backgroundPosition: "center",
            // 회원용 모니터는 하단 바가 없어 그림이 화면 전체를 덮게 한다.
            backgroundSize: did === "1" ? "cover" : undefined,
            backgroundRepeat: "no-repeat",
          }}
        ></div>
        <BottomNav />
      </div>
    </LandscapeProgramLayout>
  );
}

export default IceBreaking;
